import { remove } from "@acng/frontend-bounty";
import { queryAll } from "@acng/frontend-bounty";
import { TAGNAME_TEMPLATE } from "@acng/frontend-bounty/types";
import { rootNamespace } from "./root.js";
import { RESOURCE_CONFIG } from "../model/resource.js";
import { callConfig } from "./config/call.js";
/**
 * @returns {void}
 */
export const digest = () => walk(rootNamespace);
/**
 * @param {import("../model/resource.js").ResourceElement} namespace
 */
const walk = (namespace) => {
    for (const resource of queryAll(TAGNAME_TEMPLATE, namespace.content)) {
        if ( /** @type {import("../model/resource.js").ResourceElement} */(resource)[RESOURCE_CONFIG]) {
            callConfig(resource);
            walk(resource);
        }
        else {
            remove(resource);
        }
    }
};
